module.exports = __webpack_public_path__ + "img/9788946417809.e45bb524.jpg";